
import React from 'react';
import PropTypes from 'prop-types';
import css from './styles/PageBlockLayer.module.scss';
import AppContainer from 'stores/AppContainer';
import Blocking from 'components/Blocking';
import { Spinner } from 'react-bootstrap';

export default function PageBlockLayer(props) {
    const { blockPage, blockPageMessage, blockPageOptions } = AppContainer.useContainer();
    const message = (blockPageMessage) 
    ? blockPageMessage 
    : (
        <Spinner 
            animation="border" 
            variant="primary"
            className="d-block mx-auto position-fixed"
        />
    );
    return (
        <>
            <Blocking 
                show={ blockPage } 
                message={ message }
                messageClassName={`${css.message} ${(blockPageOptions) ? blockPageOptions.messageClassName : ''}`} 
                overLayClassName={`${css.overlay} ${(blockPageOptions) ? blockPageOptions.overLayClassName : ''}`}
            />
            { props.children }
        </>
    );
}
PageBlockLayer.propTypes = {
    children: PropTypes.element
};
    
